import React from 'react';
import { ThemeProvider } from './ThemeContext';
import ReactDOM from 'react-dom/client';
// Self-hosted fonts (WR-013 §3). These replace two Google Fonts CDN calls:
// a privacy-positioned product must not phone Google on page load. The
// variable builds ship one woff2 per family covering every weight we use.
// Imported before App.css so the @font-face rules are registered first.
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import './App.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
